module.exports = __webpack_public_path__ + "media/images/application/template/arrow-left-a0c51d950065e987751783d3d03b7f8f.svg";